// #region Estado mock (simula backend)
let _data = [
  { id: 1, nome: 'Ana Silva Santos', cpf: '123.456.789-00', telefone: '(11) 99999-9999', sexo: 'F', data_nascimento: '1985-03-14', saldo_devedor: 0, observacoes: 'Cliente fiel, prefere cortes clássicos' },
  { id: 2, nome: 'Ana Paula Oliveira', cpf: '234.567.890-12', telefone: '(11) 88888-8888', sexo: 'F', data_nascimento: '1990-07-21', saldo_devedor: 150.0, observacoes: 'Alérgica a tintura com amônia' },
  { id: 3, nome: 'João Carlos Pereira', cpf: '345.678.901-23', telefone: '(11) 77777-7777', sexo: 'M', data_nascimento: '1978-12-09', saldo_devedor: 0, observacoes: 'Prefere sábado de manhã' },
  { id: 4, nome: 'Fernanda Costa Lima', cpf: '456.789.012-34', telefone: '(11) 66666-6666', sexo: 'F', data_nascimento: '1995-05-07', saldo_devedor: 75.5, observacoes: 'Gosta de procedimentos modernos' },
  { id: 5, nome: 'Roberto Silva', cpf: '567.890.123-45', telefone: '(11) 55555-5555', sexo: 'M', data_nascimento: '1982-01-29', saldo_devedor: 0, observacoes: 'Cliente executivo, sempre pontual' },
];
// #endregion

// #region Util
const delay = (ms = 240) => new Promise(r => setTimeout(r, ms));
// #endregion

// #region Métodos CRUD
export async function listAll() {
  await delay();
  return _data.map(c => ({ ...c }));
}
export async function getById(id) {
  await delay();
  const found = _data.find(c => c.id === id);
  return found ? { ...found } : null;
}
export async function create(payload) {
  await delay();
  const id = Date.now();
  const novo = { id, saldo_devedor: 0, ...payload };
  _data = [novo, ..._data];
  return { ...novo };
}
export async function update(id, patch) {
  await delay();
  let updated = null;
  _data = _data.map(c => {
    if (c.id === id) { updated = { ...c, ...patch }; return updated; }
    return c;
  });
  return updated ? { ...updated } : null;
}
export async function remove(id) {
  await delay();
  _data = _data.filter(c => c.id !== id);
  return true;
}
// #endregion

// #region Export default (facilita troca futura por axios)
const clientesApi = { listAll, getById, create, update, remove };
export default clientesApi;
// #endregion
